// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class EmployeeVM  {
    _originalTypeClassName = "Loom.BO.EmployeeVM";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
EmployeeVM.translate = translateService;
}
this.EmployeeId = null;
this.PersonId = null;
this.FirstName = null;
this.LastName = null;
this.FullName = null;
this.CallName = null;
this.Email = null;
this.OrgId = null;
this.OrgShortName = null;
this.OrgName = null;
this.BasedInCountryName = null;
this.BasedInCountryCode = null;
this._key = this.EmployeeId = 0; 
}

static translate: TranslateService;
_key: any;
private _EmployeeId:any;
get EmployeeId(): any {
    return this._EmployeeId;
  }
set EmployeeId(value: any) {
    this._EmployeeId = value;
    this._key = value;
  }
PersonId:any;
FirstName:any;
LastName:any;
FullName:any;
CallName:any;
Email:any;
OrgId:any;
OrgShortName:any;
OrgName:any;
BasedInCountryName:any;
BasedInCountryCode:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.EmployeeId == null || $this.EmployeeId == 0;
            }


}